export default{
  postOffice: (state) => state.postOffice
}



// WEBPACK FOOTER //
// ./src/components/postOffice/store/getters.js